import helpers from "./helpers";
import api from '../services/api';

const autocomplete = async (context, payload) => {
    try {
        context.commit('SET_Q', payload);

        let params = new URLSearchParams();
        params.append('q', payload);

        const response = await api.get(
            context.state.baseUrl + '/autocomplete',
            {params})

        context.commit('SET_AUTOCOMPLETE', response.data);
        context.commit('SET_TIPS', response.data);
        context.commit('SET_AUTOCOMPLETE_CATEGORIES',response.data);
    } catch (err) {
        console.log(err);
    }
};

const setStart = async (context) => {
    try {
        context.commit("setLoading", true, { root: true });
        let params = new URLSearchParams();
        params.append('q', context.state.q);

        const response = await api.get(
            context.state.baseUrl + '/autocomplete',
            {params})
        context.commit('SET_AUTOCOMPLETE', response.data);
    } catch (err) {
        return Promise.reject(err);
    } finally {
        context.commit("setLoading", false, { root: true });
    }
};

const doSearch = async (context, from_url = false) => {
    try {
        context.commit("setLoading", true, { root: true });

        if(from_url) {
            context.dispatch('setFiltersFromUrl');
        }

        // собираем параметры
        const params = helpers.setParams(context.getters);

        if(!from_url) {
            // добавляем в history с параметром digiSearch
            context.dispatch('addUrlToBrowserHistory', params);
        }

        params.delete(context.state.searchParam);

        const response = await api.get(
            context.state.baseUrl + '/do-search',
            {params})

        context.commit("SET_IS_WAS_SEARCH", true);

        if(context.state["doSearchAddMode"]) {
            context.commit('ADD_TO_SEARCH', response.data);
            context.commit('SET_DO_SEARCH_ADD_MODE', false)
        } else {
            context.commit('SET_SEARCH', response.data);
        }

        if(response.data.redirect.length) {
            context.commit('SET_REDIRECT', response.data.redirect)
            return;
        }

        // уст. state.facets.selected (фасеты с галочкой)
        context.commit('SET_SELECTED_FACETS', response.data);

        // уст. state.facets_actual
        context.commit('SET_FACETS',{facets: response.data.facets, stf: 'facets_actual'});

        // выбранные фасеты (с галочкой)
        let selected_facets = response.data.selectedFacets;

        // обновлять полный набор
        // когда выбрана категория и хотя бы одна галочка
        // и когда категория не выбрана
        let update_facets_full = false;
        if(context.state["selected_category"] > 0) {
            if(selected_facets.length < 2) {
                update_facets_full = true;
            }
        }
        if(context.state["selected_category"] == 0) {
            if(selected_facets.length === 0) {
                update_facets_full = true;
            }
        }

        if(update_facets_full || from_url) {
            context.commit('SET_FACETS', {
                //facets: response.data.facets_all,
                facets: response.data.facets,
                stf: 'facets',
                selected_category: context.state["selected_category"]
            });
            //context.commit('SET_PRICES', {facets: response.data.facets, stf: 'facets'});
        }

        let update_prices = false;
        if(context.state['priceSelected'].length === 0) {
            update_prices = true;
        } else {
            if((context.state['priceSelected'][0] === 0) && (context.state['priceSelected'][1] === 0)) {
                update_prices = true;
            }
        }
        if(update_prices) {
            context.commit('SET_PRICES', {facets: response.data.facets, stf: 'facets'});
        }


        helpers.mergeFacets(
            context.state["facets"].availability,
            context.state["facets_actual"].availability,
            context.state["selected_param"],
            'Наличие');
        helpers.mergeFacets(
            context.state["facets"].hit,
            context.state["facets_actual"].hit,
            context.state["selected_param"],
            'Хит');
        helpers.mergeFacets(
            context.state["facets"].novelty,
            context.state["facets_actual"].novelty,
            context.state["selected_param"],
            'Новинка');
        helpers.mergeFacets(
            context.state["facets"].brands,
            context.state["facets_actual"].brands,
            context.state["selected_param"],
            'brand'
        );
        helpers.mergeFacets(
            context.state["facets"].categories,
            context.state["facets_actual"].categories,
            context.state["selected_param"],
            'category'
        );
        helpers.mergeTags(
            context.state["facets"].tags,
            context.state["facets_actual"].tags,
            context.state["selected_param"]);
        helpers.mergeFacets(
            context.state["facets"].colors,
            context.state["facets_actual"].colors,
            context.state["selected_param"],
            'Цвет');

    } catch (err) {
        return Promise.reject(err);
    } finally {
        context.commit("setLoading", false, { root: true });
    }
};

const setFiltersFromUrl = (context) => {
    const params = new URLSearchParams(decodeURIComponent(window.location.search));
    params.delete(context.state.searchParam);
    for(let pair of params.entries()) {

        if(pair[0] === 'q') {
            context.commit('SET_Q', pair[1]);
            continue;
        }
        if(pair[0] === 'size') {
            continue;
        }
        if(pair[0] === 'sort') {
            context.commit('SET_SORT', pair[1]);
            continue;
        }
        if(pair[0] === 'offset') {
            context.commit('SET_CURRENT_PAGE', pair[1]/context.state.pageSize);
            continue;
        }
        if(pair[0] === 'category') {
            context.commit('SET_SELECTED_CATEGORY', pair[1]);
            continue;
        }

        const param = {};
        param[pair[0]] = pair[1];
        context.dispatch('addFilter', param);
    }

};

const addUrlToBrowserHistory = (context, payload) => {
    payload.delete(context.state.searchParam);
    payload = encodeURIComponent(payload.toString())
    const url = '?' + context.state.searchParam + '=true&' + payload;
    window.history.pushState(null, null, url);
};

const getHistory = (context) => {
    if(localStorage.digiHistoryStorage) {
        context.commit('SET_HISTORY', JSON.parse(localStorage.digiHistoryStorage));
    }
};

const deleteFromHistory = (context, index) => {
    let history = context.getters['history']
    history.splice(index,1)
    localStorage.digiHistoryStorage = JSON.stringify(history)
    context.dispatch('getHistory');
};

const addToHistory = (context) => {
    let history = context.getters['history']
    const q = context.getters['q'];
    if(q.length === 0) {
        return;
    }

    const found = history.findIndex(function(item, index) {
        if(item.name === q) {
            return true;
        }
    });
    if(found !== -1) {
        history.splice(found, 1);
    }
    history.unshift({
        name: q,
        link_url: false,
        type: 'queries'
    });
    localStorage.digiHistoryStorage = JSON.stringify(history);
    context.dispatch("getHistory");
};

const changeMode = (context, mode) => context.commit("SET_MODE", mode);

const addFilter = (context, payload) => {
    let {queryFilters} = context.getters;

    context.commit("SET_CURRENT_PAGE", 0);

    for(let param_name in payload) {
        context.commit("SET_SELECTED_PARAM", param_name)
        if(param_name === 'category') {
            continue;
        }
        let param = queryFilters.filter(function (value) {
            return typeof value[param_name] !== 'undefined';
        });

        if(param.length) {
            if(param_name === 'minPrice' || param_name === 'maxPrice') {
                param[0][param_name] = payload[param_name];
            } else {
                param[0][param_name] = helpers.addValue(
                    param[0][param_name],
                    payload[param_name],
                    ";"
                );
            }

        } else {
            queryFilters.push(payload);
        }
    }
    context.commit("SET_QUERY_FILTER", queryFilters);
};

const removeFilter = (context, payload) => {
    let {queryFilters} = context.getters;

    context.commit("SET_CURRENT_PAGE", -1);

    for(let param_name in payload) {
        let filter_param = queryFilters.filter(function (value) {
            return typeof value[param_name] !== 'undefined';
        });

        if(filter_param.length) {

            // преобразуем в массив текущие значения параметра фильтра '25C;35C;50C;
            // [25C,35C,50C]
            let values = filter_param[0][param_name].split(";");

            // ищем значение которое нужно удалить
            let filter_value = values.filter(function (value) {
                return value===payload[param_name];
            });
            // есть что удалять
            if(filter_value.length) {
                // удаляем значение из значений параметра
                let bbb = helpers.removeValue(filter_param[0][param_name], payload[param_name], ";");
                if(bbb.length) { // если что-то осталось в значениях
                    filter_param[0][param_name] = bbb;
                } else { // значения параметра пустые, удаляем параметр
                    queryFilters = queryFilters.filter(function (value) {
                        return typeof value[param_name] === 'undefined';
                    });
                }
            }
        }
    }
    context.commit("SET_QUERY_FILTER", queryFilters);

};

const removeFilters = (context, payload) => {
    let {queryFilters} = context.getters;
    queryFilters = queryFilters.filter(function (value) {
        return Object.keys(value)[0] !== payload;
    });
    if(payload === 'minPrice') {
        context.commit("SET_PRICE_SELECTED", {min: 0, max: context.getters["priceSelected"][1]})
    }
    if(payload === 'maxPrice') {
        context.commit("SET_PRICE_SELECTED", {min: context.getters["priceSelected"][0], max: 0})
    }
    context.commit("SET_QUERY_FILTER", queryFilters);
};
const resetFilters = (context) => {
    context.commit("SET_QUERY_FILTER", []);
};
const hideSearch = (context) => {
    context.commit("SET_HIDDEN");
};
const showSearch = (context) => {
    context.commit("SET_VISIBLE");
};
const setAutocompleteMode = (context) => {
    context.commit("SET_VISIBLE");
    context.commit("SET_MODE", "start");
};
const setSearchMode = (context) => {
    context.commit("SET_VISIBLE");
    context.commit("SET_MODE", "category");
};
const clearTips = (context) => {
    context.commit("CLEAR_TIPS");
};
const clearAutocomplete = (context) => {
    context.commit("SET_AUTOCOMPLETE", {sts: [], products: [], correction: []});
    context.commit("SET_AUTOCOMPLETE_CATEGORIES", {categories: []});
};
const selectCategory = (context, payload) => context.commit("SET_SELECTED_CATEGORY", payload);
const setQString = (context, q) => context.commit("SET_Q", q);
const setMobile = (context, payload) => context.commit("SET_MOBILE", payload);
const setIE = (context, payload) => context.commit("SET_IE", payload);
const sendSortSelectEvent = (context) => context.dispatch("doSearch");
const setCurrentPage = (context, payload) => context.commit('SET_CURRENT_PAGE', payload);
const setDoSearchAddMore = (context, payload) => context.commit('SET_DO_SEARCH_ADD_MODE', payload);
const setPriceSelected = (context, payload) => context.commit('SET_PRICE_SELECTED', payload);
const setSort = (context, payload) => context.commit('SET_SORT', payload);
const setShowSortMobile = (context, payload) => context.commit('SET_SHOW_SORT_MOBILE', payload);
const setPagination = (context, payload) => context.commit('SET_PAGINATION', payload);
const setQueryFilter = (context, payload) => context.commit('SET_QUERY_FILTER', payload);
//const setSelectedCategory = (context, payload) => context.commit('SET_SELECTED_CATEGORY', payload);
const renderInstantSearch = (context) => {

};
const sendSortOpenEvent = (context) => {

};
const setSearchParam = (context, payload) => context.commit('SET_SEARCH_PARAM', payload);
const setHeaderSelector = (context, payload) => context.commit('SET_HEADER_SELECTOR', payload);
const setApiKey = (context, payload) => context.commit('SET_API_KEY', payload);
const setBaseUrl = (context, payload) => context.commit('SET_BASE_URL', payload);

const setBodyClasses = (context) => {
    const el = document.body;
    el.classList.add('sm-disable-scroll');
    if(context.getters['isMobile']) {
        el.classList.add('sm-body_mobile');
    }
}

const toggleOpenFacets = (context) => {
    context.state.isOpenFacets = !context.state.isOpenFacets;
    //(this.isOpenFacets = !this.isOpenFacets), this.isOpenFacets && this.$store.dispatch("sendOpenFacetsEvent");
}

const setCurrentOpenFacet = (context, payload) => context.commit('SET_CURRENT_OPEN_FACET', payload);

const setCorrectPosition = (context) => {
    let top = "0"; let btm = "35";
    if(!context.getters['isMobile']) {
        let e = helpers.getCoordinates(context.getters['headerSelector']);
        top = e.top;
        //btm = "20";
    }
    /*if(context.getters['mode'] === 'start') {
        btm = "1";
    }*/

    let el = document.getElementsByClassName('sm-shield');
    let div = el[0];

    div.style.top = (context.getters['isMobile']) ? 0 : "".concat(top, "px");
    //div.style.height = "calc(100vh - ". concat(btm, "px)");

    //console.log('setCorrectPosition', top)
}

const closeSearch = (context) => {
    context.dispatch("hideSearch")
    context.dispatch("setQueryFilter", []);
    context.dispatch("setQString", '');
    document.body.classList.remove('sm-disable-scroll');
    window.history.replaceState({}, document.title, window.location.pathname);
}
// Доп функционал фильтра товаров категории
const setCategoryFilter = (context) => {
    context.commit("SET_CATEGORY_FILTER", true)
}
const setProducts = (context, payload) => {
    context.commit("SET_SEARCH", payload);
}
const setEmbeddedMode = (context, catalog_container) => {
    let sel = document.getElementById(context.getters['searchParam']);
    let container = document.getElementById(catalog_container);
    sel.style.height = "auto";
    sel.style.top = "auto";
    sel.style.position = "inherit";

    let fragment = document.createDocumentFragment();
    fragment.appendChild(sel);
    container.replaceWith(fragment);
}

export default {
    autocomplete,
    setStart,
    doSearch,
    getHistory,
    deleteFromHistory,
    addToHistory,
    changeMode,
    addFilter,
    removeFilter,
    removeFilters,
    resetFilters,
    hideSearch,
    showSearch,
    setAutocompleteMode,
    setSearchMode,
    selectCategory,
    setQString,
    setMobile,
    setIE,
    sendSortSelectEvent,
    renderInstantSearch,
    sendSortOpenEvent,
    setFiltersFromUrl,
    addUrlToBrowserHistory,
    setCurrentPage,
    setDoSearchAddMore,
    setPriceSelected,
    setSort,
    setShowSortMobile,
    setPagination,
    setQueryFilter,
    //setSelectedCategory,
    setSearchParam,
    setHeaderSelector,
    setApiKey,
    setBaseUrl,
    setBodyClasses,
    toggleOpenFacets,
    setCurrentOpenFacet,
    setCorrectPosition,
    closeSearch,
    clearTips,
    clearAutocomplete,
    setCategoryFilter,
    setProducts,
    setEmbeddedMode
};